import Model from './model';





export default Model.extend( {

    endpoint: 'types', responseAt: 'newstype',
    
    defaults() {
        return {
            name: '',
            cluster: null,
            group_id: null, 
            period_of_review_in_sec: undefined,
            deadline_type: 'AT_CREATE',
            default_type: 'f',
            departments: [],
            icon: 'default_icon.png',
        };
    },

    customParser(payload) {
        if (payload.period_of_review_in_sec)
            payload.period_of_review_in_sec = +payload.period_of_review_in_sec;

        return payload;
    },
    
} );


// WEBPACK FOOTER //
// ./src/js/model/newstype.js